import type { Dimension } from '../types/question.js';

/** Display labels for each dimension. */
export const DIMENSION_LABELS: Record<Dimension, string> = {
  basics: '基础认知',
  preflop: '翻牌前',
  flop: '翻牌',
  turnRiver: '转河复杂处理',
};

/**
 * Composite score weights. Must sum to 1.0.
 * Tuned later once real question pool exists.
 */
export const DIMENSION_WEIGHTS: Record<Dimension, number> = {
  basics: 0.20,
  preflop: 0.25,
  flop: 0.25,
  turnRiver: 0.30,
};

/**
 * Difficulty multiplier applied when computing per-question score.
 * Easier questions count slightly less, harder questions slightly more.
 */
export const DIFFICULTY_COEFFICIENTS: Record<1 | 2 | 3 | 4 | 5, number> = {
  1: 0.6,
  2: 0.8,
  3: 1.0,
  4: 1.2,
  5: 1.5,
};
